export default __webpack_public_path__ + "static/media/IMG-20241005-WA0036.27042f7c.jpg";